<script setup lang="ts">
import { ArrowLeftIcon } from 'lucide-vue-next'

const { backContent, customRedirect } = defineProps<{
  /** Custom text to display instead of the default "back" */
  backContent?: string
  /** Custom redirect path instead of router.back() */
  customRedirect?: string
}>()

const { t } = useI18n()
const router = useRouter()

function handleBack() {
  if (customRedirect) {
    router.push(customRedirect)
  }
  else {
    router.back()
  }
}
</script>

<template>
  <div class="text-primary flex items-center gap-2 cursor-pointer w-fit" @click="handleBack">
    <ArrowLeftIcon :size="18" />
    <span class="font-semibold text-sm">
      {{ backContent || t('global.back') }}
    </span>
  </div>
</template>
